import { Badge } from "@dune/ui";
import { ReceiptType, receiptTypeLabels } from "@dune/vars";

export const ReceiptTypeBadge = ({ type }: { type: ReceiptType }) => {
	const label = receiptTypeLabels[type];
	return <Badge variant="default">{label}</Badge>;
};
